import moment from "moment";

const viewTypes = {
  dayGridMonth: "dayGridMonth",
  timeGridWeek: "timeGridWeek",
  listWeek: "listWeek",
  listDay: "listDay"
};

function isValidView(view) {
  return !!viewTypes[view];
}

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

const DEVICE_DEFAULT_VIEW = isMobile() ? "listDay" : "dayGridMonth";

export function forceViewValid(view, defaultView = DEVICE_DEFAULT_VIEW) {
  return isValidView(view) ? view : defaultView;
}

function isValidDate(date) {
  if (date == null) return;
  return moment(date, "YYYY-MM-DD", true).isValid();
}

export function forceDateValid(
  date,
  defaultDate = moment().format("YYYY-MM-01")
) {
  return isValidDate(date) ? date : defaultDate;
}
